import React, { useState, useEffect } from "react";
import "./subscriptionBundles.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory, useParams } from "react-router-dom";
import { ArrowBack } from "@material-ui/icons";
import { getBundles } from "../../services/subscriptions.services.js";

export default function SubscriptionBundles(props) {
  const [bundleData, setBundleData] = useState(null);
  const [loading, setLoading] = useState(false);


  const { id } = useParams();

  useEffect(() => {
    const fnt = async () => {
      try {
        setLoading(true);
        const response = await getBundles(
          JSON.parse(sessionStorage.getItem("myData"))
        );
        console.log("bundlessssssss found ==>>>", response.data);
        setBundleData(response.data);
      } catch (err) {
        console.log("errorrrrrrrr at bundles", err);
      } finally {
        setLoading(false);
      }
    };
    fnt();
  }, []);

  useEffect(() => {
    console.log("88", bundleData);
  }, [bundleData]);

  let history = useHistory();

  return (
    <div className="bundles">
      <div className="bundlesHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="bundlesTitle">Subscription Bundles</h1>
        </div>
        <img
          className="bundlesLogo"
          src={logoBlue}
          alt="logo"
          width="150px"
        ></img>
      </div>

      {bundleData?.map((item) => {
        return (
          <div className="bundlesContainer">
            <h1 className="bundlesTxt">{item?.title}</h1>

            <div className="priceView">
              <p className="priceBundle">Price: {item?.price}$</p>
              <div className="line" />
              <p className="priceBundle">Usages: {item?.numberOfUsage}</p>
            </div>

            <h2 className="featuresTxt">Features</h2>
            <ul>
              {item.features.map((feature, index) => (
                <li key={index} className="featureListItem">
                  <strong>{feature.name}: &nbsp;</strong>
                  <p>{feature.description}</p>
                  <p className="availability">
                    {feature.available ? (
                      <span>&#10003;</span>
                    ) : (
                      <span>&#10007;</span>
                    )}
                  </p>
                </li>
              ))}
            </ul>
            <Link to={"/updateBundle/" + id}>
            <button className="editUserBtn">Edit</button>
          </Link>
          </div>
        );
      })}

      <div className="bundlesAdd">
        <Link to={"/createBundle"}>
          <button className="plusBtn">+</button>
        </Link>
      </div>
    </div>
  );
}
